import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import { configForm } from 'pages/admin/config/config-form';
import { forgotPasswordForm, loginForm, registerForm, sessionCallback, userProfile } from 'pages/auth';
import { notFoundPage } from 'pages/error';
import { Home } from 'pages/home/home';
import { ProductForm, ProductList, StockOpname } from 'pages/seller/product';
import { ProductDetail as Product } from 'pages/seller/product/ProductDetail';
import { Chart } from 'pages/seller/report';
import { ratingForm } from 'pages/transaction/rating/rating-form';

import Affiliate from 'screens/Affiliate';
import ComingSoon from 'screens/ComingSoon';
import Dashboard from 'screens/Dashboard';
import { FillParticipant } from 'screens/FillParticipant';
import PaymentInstruction from 'screens/PaymentInstruction';
import PreOrderInternal from 'screens/PreOrderInternal';
import ProductDetail from 'screens/ProductDetail';
import Report from 'screens/Report';
import ResetPassword from 'screens/ResetPassword';
import ShippingDoc from 'screens/ShippingDoc';

import TicketList from 'screens/Ticket';
import { AddressForm, AddressList } from 'screens/Transaction';
import NewOrderCertificate from 'screens/Transaction/NewOrderCertificate';
import NewOrderProduct from 'screens/Transaction/NewOrderProduct';
import NewPreOrderInternal from 'screens/Transaction/NewPreOrderInternal';
import NewPreOrderMember from 'screens/Transaction/NewPreOrderMember';
import TransactionAddTicket from 'screens/TransactionAddTicket';
import TransactionConfirmation from 'screens/TransactionConfirmation';
import TransactionDetail from 'screens/TransactionDetail';
import TransactionList from 'screens/TransactionList';
import TransactionTicket from 'screens/TransactionTicket';

const Routes = (
  <Router>
    <Switch>
      <Route exact path="/" component={Home} />
      <Route exact path="/login" component={loginForm} />
      <Route exact path="/register" component={registerForm} />
      <Route exact path="/forgot-password" component={forgotPasswordForm} />
      <Route exact path="/session" component={sessionCallback} />
      <Route exact path="/profil" component={userProfile} />
      <Route exact path="/pengaturan" component={configForm} />
      <Route exact path="/produk" component={ProductList} />
      <Route exact path="/produk-baru" component={ProductForm} />
      <Route exact path="/stok-opname" component={StockOpname} />
      <Route exact path="/beri-penilaian/:id" component={ratingForm} />
      <Route exact path="/pre-order-internal" component={PreOrderInternal} />
      <Route exact path="/grafik" component={Chart} />
      <Route exact path="/alamat">
        <AddressList />
      </Route>
      <Route exact path="/alamat/:id">
        <AddressForm />
      </Route>
      <Route exact path="/coming-soon" component={ComingSoon} />
      <Route exact path="/dasbor" component={Dashboard} />
      <Route exact path="/affiliate" component={Affiliate} />
      <Route exact path="/konfirmasi-pesanan" component={TransactionConfirmation} />
      <Route exact path="/pesan-produk" component={NewOrderProduct} />
      <Route exact path="/pesan-sertifikat" component={NewOrderCertificate} />
      <Route exact path="/pesan-pre-order-member" component={NewPreOrderMember} />
      <Route exact path="/pesan-pre-order-internal" component={NewPreOrderInternal} />
      <Route exact path="/pesan-tiket" component={TransactionAddTicket} />
      <Route exact path="/pembayaran/:id" component={PaymentInstruction} />
      <Route exact path="/produk/:id" component={ProductDetail} />
      <Route exact path="/produk-detail" component={Product} />
      <Route exact path="/reset-password" component={ResetPassword} />
      <Route exact path="/tiket-gtw" component={FillParticipant} />
      <Route exact path="/tiket" component={TicketList} />
      <Route exact path="/transaksi" component={TransactionList} />
      <Route exact path="/transaksi/:id" component={TransactionDetail} />
      <Route exact path="/transaksi/:id/tiket" component={TransactionTicket} />
      <Route exact path="/lembar-pengiriman/:id" component={ShippingDoc} />
      <Route exact path="/laporan" component={Report} />
      <Route component={notFoundPage} />
    </Switch>
  </Router>
);

export default Routes;
